"use client";

import Image from "next/image";
import { useTranslations } from "next-intl";

const ICON_BASE = "/image/new-version/ValueAddedSolutions/assembly/图标/图标-1";

const CARDS = [
	{
		keyPrefix: "whyChooseCard1",
		icon: `${ICON_BASE}/precision-assembly.svg`,
		variant: "dark",
	},
	{
		keyPrefix: "whyChooseCard2",
		icon: `${ICON_BASE}/fast-lead-time.svg`,
		variant: "primary",
	},
	{
		keyPrefix: "whyChooseCard3",
		icon: `${ICON_BASE}/experienced-technicians.svg`,
		variant: "soft",
	},
] as const;

const cardClassName = {
	dark: "bg-black text-white",
	primary: "bg-[#0d8506] text-white",
	soft: "bg-[#a9c894] text-white",
} as const;

export default function AssemblyWhyChoose() {
	const t = useTranslations("new-assembly");

	return (
		<section className="bg-white py-8 sm:py-10 md:py-12 lg:py-16">
			<div className="container">
				<div className="grid gap-6 md:grid-cols-3 md:gap-8">
					{CARDS.map((card) => (
						<article
							key={card.keyPrefix}
							className={`relative min-h-[240px] overflow-hidden p-6 sm:p-7 ${cardClassName[card.variant]}`}
						>
							<div className="mb-5 flex items-start justify-between gap-5">
								<p className="text-sm font-semibold text-themePrimary400">{t(`${card.keyPrefix}Number`)}</p>
								<div className="flex h-16 w-16 shrink-0 items-center justify-center rounded-full bg-white p-3 sm:h-20 sm:w-20">
									<Image
										src={card.icon}
										alt={t(`${card.keyPrefix}ImageAlt`)}
										width={56}
										height={56}
										className="h-full w-full object-contain"
									/>
								</div>
							</div>
							<h2 className="mb-3 text-lg font-bold leading-tight sm:text-xl md:text-2xl">
								{t(`${card.keyPrefix}Title`)}
							</h2>
							<p className="text-sm leading-relaxed text-white/90 md:text-base">
								{t(`${card.keyPrefix}Desc`)}
							</p>
						</article>
					))}
				</div>
			</div>
		</section>
	);
}
